<template>
	<button
		type="button"
		class="btn"
		:class="classObject"
		@click="click"
		v-html="displayLabel"
	></button>
</template>
<script>
	import {buttonMixin} from './mixin-input';
	export default {
		mixins: [buttonMixin]
	};
</script>



// WEBPACK FOOTER //
// input-button.vue?f429e6a0